import FullInfoField from 'components/FullInfoField/FullInfoField';
import React from 'react';
import { ICustomerLocalizationItem } from 'types';
import style from './LocalizationItem.module.scss';

interface ILocalizationItem {
	itemData: ICustomerLocalizationItem;
	languageId: string;
}

const LocalizationItem: React.FC<ILocalizationItem> = ({ itemData, languageId }) => {
	const translationData = itemData.translations.find((el) => el.languageId === languageId);

	return (
		<FullInfoField
			containerClassName={style.container}
			label={itemData.key}
			value={translationData?.value}
			translationNameSpace="localizationSettings"
		/>
	);
};

export default LocalizationItem;
